module.exports = __webpack_public_path__ + "static/media/american-express.e5bf0c8d.svg";